import { Trans } from 'react-i18next'
import clsx from 'clsx'

import { IPluginPresenter } from '@makyoapp/makyo-sdk/models/Plugins'
import { Check16, Info16, Setting24, Trash16 } from '@makyoapp/makyo-icon/icon'
import { MoreDropdown } from '@makyoapp/makyo-ui'

interface Props {
  plugin: IPluginPresenter
  onInfoClick?(id: string): void
  onSettingClick?(id: string): void
}

export function AuthPluginItem({ plugin, onInfoClick, onSettingClick }: Props) {
  const isActive = plugin._Active

  return (
    <div
      className={clsx(
        'p-2 flex items-start gap-2 rounded-sm border bdr max-w-[200px] overflow-hidden',
        'hover:bg-primary-50 dark:hover:bg-slate-900',
        isActive && 'border-primary-500!'
      )}
    >
      <div className='flex-c h-full w-full'>
        <img src={plugin._Icon} alt='' className='w-6 h-6 object-contain' width={24} height={24} />
        {isActive ? (
          <div className='text-m-sm flex flex-col'>
            <div>{plugin._Name}</div>
            <div className='uppercase text-m-ss link'>
              <Trans>Active</Trans>
            </div>
          </div>
        ) : (
          <div>{plugin._Name}</div>
        )}
      </div>

      <MoreDropdown>
        <MoreDropdown.MenuItem onClick={() => onInfoClick?.(plugin._id)}>
          <Info16 />
          <Trans>Info</Trans>
        </MoreDropdown.MenuItem>
        <MoreDropdown.MenuItem onClick={() => onSettingClick?.(plugin._id)}>
          <Setting24 width={16} height={16} />
          <Trans>Settings</Trans>
        </MoreDropdown.MenuItem>
      </MoreDropdown>
    </div>
  )
}
